import FancyHeading from '@/components/FancyHeading';
import { MEDIA_URL } from '@/constants/env';
import { fadeInUp } from '@/constants/motions';
import Image from '@/ui/Image';
import { motion } from 'framer-motion';

export default function DeliveredProjectsBlock({ projects }) {
  const safeProjects = projects || { galleryTitle: '', galleryImages: [] };
  return (
    <motion.section
      className="my-16 px-4"
      initial="hidden"
      transition={{
        ...fadeInUp.transition,
        when: 'beforeChildren',
        staggerChildren: 0.4,
      }}
      variants={fadeInUp}
      viewport={fadeInUp.viewport}
      whileInView="visible"
    >
      <div className="container-screen">
        <FancyHeading variants={fadeInUp}>{safeProjects.galleryTitle || ''}</FancyHeading>
        <motion.div
          className="mt-8 grid gap-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4"
          variants={fadeInUp}
        >
          {(safeProjects.galleryImages || []).map(({ image }, i) => {
            const url = image?.data?.attributes?.url || '';
            if (!url) return null;
            return (
              <div key={i} className="overflow-hidden rounded-xl">
                <Image
                  alt="Project photo"
                  className="aspect-square object-cover transition duration-200 ease-linear hover:scale-105"
                  src={MEDIA_URL.concat(url)}
                />
              </div>
            );
          })}
        </motion.div>
      </div>
    </motion.section>
  );
}
